__turbopack_context__.v({
  "chatContent": "AdminChatContent-module__q1qGHW__chatContent",
  "chatContent__container": "AdminChatContent-module__q1qGHW__chatContent__container",
  "chatContent__containerPlaceholder": "AdminChatContent-module__q1qGHW__chatContent__containerPlaceholder",
  "chatContent__footer": "AdminChatContent-module__q1qGHW__chatContent__footer",
  "chatContent__footer__buttonGroup": "AdminChatContent-module__q1qGHW__chatContent__footer__buttonGroup",
  "chatContent__footer__thread": "AdminChatContent-module__q1qGHW__chatContent__footer__thread",
  "chatFadeIn": "AdminChatContent-module__q1qGHW__chatFadeIn",
});
